// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
/**
 * @description Retrieve the list of all validator stashes
 */

export function stashes(instanceId, api) {
  return memo(instanceId, () => api.query.staking.validators.keys().pipe(map(keys => keys.map(({
    args: [validatorId]
  }) => validatorId).filter(a => a))));
}